export const ADD_FIRST_PAGE = '@/ADD_FIRST_PAGE';

export const SET_MODE = '@/SET_MODE';
export const SET_PRESELECTED_PRINTER = '@/SET_PRESELECTED_PRINTER';
export const SET_PRINTER_LIST = '@/SET_PRINTER_LIST';

export const SET_EDITOR_MENU_TAB = '@/SET_EDITOR_MENU_TAB';

export const SELECT_PAGE = '@/SELECT_PAGE';
export const SELECT_SHIELD = '@/SELECT_SHIELD';
export const SELECT_SECTION = '@/SELECT_SECTION';
export const ADD_SELECTED_SECTIONS = '@/ADD_SELECTED_SECTIONS';
export const EDIT_SECTION = '@/EDIT_SECTION';
export const MOVE_SECTION = '@/MOVE_SECTION';
export const GENERATE_BMP = '@/GENERATE_BMP';
export const DELETE_SECTION = '@/DELETE_SECTION';
export const DELETE_SECTIONS = '@/DELETE_SECTIONS';
export const DELETE_SELECTED_SECTIONS = '@/DELETE_SELECTED_SECTIONS';
export const ADD_PAGE = '@/ADD_PAGE';
export const DELETE_PAGE = '@/DELETE_PAGE';
export const SET_EDITOR_TAB = '@/SET_EDITOR_TAB';
export const DELETE_PAGE_CONTENT = '@/DELETE_PAGE_CONTENT';
export const OVERRIDE_PAGE = '@/OVERRIDE_PAGE';
export const OVERRIDE_PAGES = '@/OVERRIDE_PAGES';
export const SET_CELL_SELECTION_TYPE = '@/SET_CELL_SELECTION_TYPE';
export const SET_GROUP_SELECTION_TYPE = '@/SET_GROUP_SELECTION_TYPE';

export const ADD_SHIELD_TO_SELECTION = '@/ADD_SHIELD_TO_SELECTION';
export const REMOVE_SHIELD_FROM_SELECTION = '@/REMOVE_SHIELD_FROM_SELECTION';
export const SWITCH_SELECTED_SHIELD = '@/SWITCH_SELECTED_SHIELD';

export const REMOVE_SECTION_FROM_SELECTION = '@/REMOVE_SECTION_FROM_SELECTION';
export const SWITCH_SELECTED_SECTION = '@/SWITCH_SELECTED_SECTION';

export const REMOVE_PAGE_FROM_SELECTION = '@/REMOVE_PAGE_FROM_SELECTION';
export const SWITCH_SELECTED_PAGE = '@/SWITCH_SELECTED_PAGE';

export const CLEAR_PAGES_SELECTION = '@/CLEAR_PAGES_SELECTION';
export const CLEAR_SHIELDS_SELECTION = '@/CLEAR_SHIELDS_SELECTION';
export const CLEAR_SECTIONS_SELECTION = '@/CLEAR_SECTIONS_SELECTION';
export const CLEAR_FICTIVE_SECTIONS_SELECTION =
  '@/CLEAR_FICTIVE_SECTIONS_SELECTION';
export const CLEAR_SELECTED_SECTIONS = '@/CLEAR_SELECTED_SECTIONS';
export const CLEAR_ALL_SELECTED_SECTIONS = '@/CLEAR_ALL_SELECTED_SECTIONS';

export const SPLIT_SECTIONS = '@/SPLIT_SECTIONS';
export const SPLIT_SECTION_VERTICAL = '@/SPLIT_SECTION_VERTICAL';
export const SPLIT_SECTION_HORIZONTAL = '@/SPLIT_SECTION_HORIZONTAL';

export const SET_COLORED_STATE = '@/SET_COLORED_STATE';
export const SET_SECTIONS_DISPLAY_STATE = '@/SET_SECTIONS_DISPLAY_STATE';
export const SET_GRID_DISPLAY_STATE = '@/SET_GRID_DISPLAY_STATE';
export const SET_GRID_WIDTH = '@/SET_GRID_WIDTH';
export const SET_INPUT_DISPLAY_STATE = '@/SET_INPUT_DISPLAY_STATE';
export const SET_TEXT_TYPING_RESOURCE = '@/SET_TEXT_TYPING_RESOURCE';

export const SET_TEMPORARY_VIEWBOX_X = '@/SET_TEMPORARY_VIEWBOX_X';
export const SET_TEMPORARY_VIEWBOX_Y = '@/SET_TEMPORARY_VIEWBOX_Y';
export const SET_VIEWBOX_X = '@/SET_VIEWBOX_X';
export const SET_VIEWBOX_Y = '@/SET_VIEWBOX_Y';
export const SET_VIEWBOX_DX = '@/SET_VIEWBOX_DX';
export const SET_VIEWBOX_DY = '@/SET_VIEWBOX_DY';

export const TOGGLE_ZOOM_STATE = '@/TOGGLE_ZOOM_STATE';
export const SET_SCALE_COEF = '@/SET_SCALE_COEF';

export const SET_FONT_COEF = '@/SET_FONT_COEF';

export const UNDO_STEP = '@/UNDO_STEP';
export const REDO_STEP = '@/REDO_STEP';

export const CLEAR_GROUP_SELECTION = '@/CLEAR_GROUP_SELECTION';

export const BULK_SHAPE_SELECTION = '@/BULK_SHAPE_SELECTION';

export const ADD_SECTION = '@/ADD_SECTION';
export const ADD_SECTIONS = '@/ADD_SECTIONS';
export const ADD_NEW_SECTIONS = '@/ADD_NEW_SECTIONS';

export const CREATE_SNAPSHOT = '@/CREATE_SNAPSHOT';
export const CREATE_INIT_SNAPSHOT = '@/CREATE_INIT_SNAPSHOT';

export const COPY_SEL_WIZARD_CONTENT = '@/COPY_SEL_WIZARD_CONTENT';
export const CMME_STATES = '@/CMME_STATES';

export const ADD_CUSTOM_FONT_COLOR = '@/ADD_CUSTOM_FONT_COLOR';
export const ADD_CUSTOM_SECTION_BORDER_COLOR =
  '@/ADD_CUSTOM_SECTION_BORDER_COLOR';
export const ADD_CUSTOM_SECTION_FILL_COLOR = '@/ADD_CUSTOM_SECTION_FILL_COLOR';
export const ADD_CUSTOM_SYMBOL_STROKE_COLOR =
  '@/ADD_CUSTOM_SYMBOL_STROKE_COLOR';
export const ADD_CUSTOM_SYMBOL_FILL_COLOR = '@/ADD_CUSTOM_SYMBOL_FILL_COLOR';

export const SET_TARGET_DEVICE = '@/SET_TARGET_DEVICE';

export const LOAD_PROJECT_FILE = '@/LOAD_PROJECT_FILE';
export const SET_PROJECT_NAME = '@/SET_PROJECT_NAME';

export const SET_AUTOFILL_SETTINGS_VISIBLE = '@/SET_AUTOFILL_SETTINGS_VISIBLE';

export const RESET_STATE = '@/RESET_STATE';

export const SET_LOCALE = '@/SET_LOCALE';

export const SET_LAST_SAVED_PAGES = '@/SET_LAST_SAVED_PAGES';

export const SET_PAGE_RESIZE_TYPE = '@/SET_PAGE_RESIZE_TYPE';

export const SET_PAGE_LENGTH = '@/SET_PAGE_LENGTH';

export const SET_PAGINATION_PAGE_NUM = '@/SET_PAGINATION_PAGE_NUM';

export const SET_COLOR_SCHEMA = '@/SET_COLOR_SCHEMA';
export const SET_RIBBON_COLOR = '@/SET_RIBBON_COLOR';
export const SET_PAPER_COLOR = '@/SET_PAPER_COLOR';
export const SET_MULTI_COLORED_STATE = '@/SET_MULTI_COLORED_STATE';

export const SET_SHOW_LOADER_STATE = '@/SET_SHOW_LOADER_STATE';

export const SET_CONTENT_PLACING_DEBUGGING_STATE =
  '@/SET_CONTENT_PLACING_DEBUGGING_STATE';
export const SET_DEBUGGING_GRID_STATE = '@/SET_DEBUGGING_GRID_STATE';

export const SET_USER_SIZE_UNIT = '@/SET_USER_SIZE_UNIT';

export const SET_FROM_WIZARD_STATE = '@/SET_FROM_WIZARD_STATE';
export const SET_WIZARD_DATA = '@/SET_WIZARD_DATA';
export const SET_IS_CABLE_FLAG_SYNC = '@/SET_IS_CABLE_FLAG_SYNC';
export const SET_SHOW_INSERT_MODAL_STATE = '@/SET_SHOW_INSERT_MODAL_STATE';

export const ADD_PAGE_ROTATION = '@/ADD_PAGE_ROTATION';
export const ADD_PAGE_MIRROR_X = '@/ADD_PAGE_MIRROR_X';
export const ADD_PAGE_MIRROR_Y = '@/ADD_PAGE_MIRROR_Y';

export const SET_SNACKBAR_STATE = '@/SET_SNACKBAR_STATE';

export const SET_USER_DEVICE_MANIPULATOR_TYPE =
  '@/SET_USER_DEVICE_MANIPULATOR_TYPE';

export const SET_OTHER_CONTENT_STATE = '@/SET_OTHER_CONTENT_STATE';
export const SET_AUTOFILL_AND_COPPY_PATTERN =
  '@/SET_AUTOFILL_AND_COPPY_PATTERN';

export const ZOOM_CUSTOM_SCALE_SEED_COEFICIENT = 0.005;

export const USER_SIZE_UNIT_MM = 'mm';
export const USER_SIZE_UNIT_INCH = 'inch';

export const OUTPUT_PROJECT_FILE_NAME = 'SchemaSnapshot.mproj';
export const OUTPUT_PAGE_IMAGE_FILE_NAME = 'output.png';
export const OUTPUT_PAGE_SVG_FILE_NAME = 'output.svg';

export const SET_FICTIVE_SECTIONS = '@/SET_FICTIVE_SECTIONS';
export const ADD_SECTION_TO_MATRIX_SELECTION =
  '@/ADD_SECTION_TO_MATRIX_SELECTION';
export const REMOVE_SECTION_FROM_MATRIX_SELECTION =
  '@/REMOVE_SECTION_FROM_MATRIX_SELECTION';

export const SET_FONT_SIZE_COEF = '@/SET_FONT_SIZE_COEF';
export const SET_LETTER_SPACING_COEF = '@/SET_LETTER_SPACING_COEF';

export const TOP = 'TOP';
export const MIDDLE = 'MIDDLE';
export const BOTTOM = 'BOTTOM';

export const LEFT = 'LEFT';
export const CENTER = 'CENTER';
export const RIGHT = 'RIGHT';

export const REMOVE_BLUR_FROM_ALL_INPUTS = '@/REMOVE_BLUR_FROM_ALL_INPUTS';

export const APP_ENVIRONMENT = {
  WEB_COMPONENT: 'web_component',
};

export const BARCODE_ALIGNMENT = {
  left: LEFT,
  center: CENTER,
  right: RIGHT,
  above: TOP,
  middle: MIDDLE,
  below: BOTTOM,
};

export const NON_BREAKING_SPACE_SYMBOL = String.fromCharCode(0x200b);

export const SET_VARIANT_COLOR_MODAL_OPEN = '@/SET_VARIANT_COLOR_MODAL_OPEN';
export const SET_FLOATABLE_INPUT_VISIBLE = '@/SET_FLOATABLE_INPUT_VISIBLE';
export const SET_PRINTING = '@/SET_PRINTING';

const TOP_LEFT = 'TOP_LEFT';
const TOP_RIGHT = 'TOP_RIGHT';
const BOTTOM_LEFT = 'BOTTOM_LEFT';
const BOTTOM_RIGHT = 'BOTTOM_RIGHT';

export const CROP_ALIGNMENT = {
  TOP_LEFT,
  TOP_RIGHT,
  BOTTOM_LEFT,
  BOTTOM_RIGHT,
};

export const MATERIAL_VARIANT_COLOR = {
  BK: 'BK',
  YE: 'YE',
  WH: 'WH',
  GN: 'GN',
  BU: 'BU',
  RD: 'RD',
  SR: 'SR',
  OG: 'OG',
  GY: 'GY',
  TR: 'TR',
};

export const DEFAULT_CONTRAST_VALUE = 35;
